import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/shared/services/data.svc';


@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {

  public show: boolean = false;
  public email: any;

  constructor(public svcData: DataService) { }

  ngOnInit() {
  }

  showPassword() {
    this.show = !this.show;
  }

  submit(){
    console.log(this.email);
    
    this.svcData.forgotPassword(this.email).subscribe(res => {
      if(res.status == "OK"){
        alert(res.data);
      }
    })
  }

}
